/* eslint-disable no-console */
// utils/gestion.js
import toast from "react-hot-toast";
import { client } from ".";

// utils/gestion.js
export const getCostosGestion = async ({ pais, ano }) => {
  try {
    const { data, error } = await client
      .from("costos_gestion_contenidos")
      .select("mes, software_ds, otros")
      .eq("pais", pais)
      .eq("ano", ano)
      .is("negocio_id", null); // ← Solo globales (null negocio_id)

    if (error) throw error;

    const mapa = Array(12)
      .fill()
      .map(() => ({ software_ds: 0, otros: 0 }));
    (data || []).forEach((row) => {
      const i = row.mes - 1;
      if (i >= 0 && i < 12) {
        mapa[i].software_ds = Number(row.software_ds) || 0;
        mapa[i].otros = Number(row.otros) || 0;
      }
    });

    return mapa;
  } catch (error) {
    console.error("Error en getCostosGestion:", error);
    return Array(12)
      .fill()
      .map(() => ({ software_ds: 0, otros: 0 }));
  }
};

export const upsertCostoGestion = async ({ negocio_id = null, pais, ano, mes, tipo, value = 0 }) => {
  try {
    const { data, error } = await client.from("costos_gestion_contenidos").upsert(
      {
        negocio_id: negocio_id || null, // ← Permite null para globales
        pais,
        ano: Number(ano),
        mes: Number(mes),
        [tipo]: Number(value) || 0,
      },
      { onConflict: "pais,ano,mes" } // ← Sin negocio_id en conflicto, ya que es opcional
    );

    if (error) throw error;
    return data;
  } catch (error) {
    console.error("Error guardando costo:", error);
    toast.error("Error al guardar costo");
    throw error;
  }
};

export const upsertCostosPublicidad = async (data) => {
  const { data: result, error } = await client.from("costos_publicidad").upsert(data, { onConflict: "pais,ano,mes" });

  if (error) throw error;
  return result;
};

export const getCostosPublicidad = async ({ pais, ano }) => {
  const { data, error } = await client.from("costos_publicidad").select("*").eq("pais", pais).eq("ano", ano);

  if (error) throw error;

  // Devolver array de 12 meses, con valores o 0
  const mapa = Array(12)
    .fill()
    .map(() => ({
      servicios_internet: 0,
      software_ds: 0,
      mantenimiento: 0,
    }));

  data?.forEach((row) => {
    const mesIndex = parseInt(row.mes, 10) - 1;
    if (mesIndex >= 0 && mesIndex < 12) {
      mapa[mesIndex] = {
        servicios_internet: Number(row.servicios_internet) || 0,
        software_ds: Number(row.software_ds) || 0,
        mantenimiento: Number(row.mantenimiento) || 0,
      };
    }
  });

  return mapa;
};
